import AUStates from './zh-CN/AU-states.json.js';
import CAStates from './zh-CN/CA-states.json.js';
import CNStates from './zh-CN/CN-states.json.js';
import CompanySize from './zh-CN/company-size.json.js';
import CompanyType from './zh-CN/company-type.json.js';
import countries from './zh-CN/countries.json.js';
import DEStates from './zh-CN/DE-states.json.js';
import HKStates from './zh-CN/HK-states.json.js';
import INStates from './zh-CN/IN-states.json.js';
import industry from './zh-CN/industry.json.js';
import interests from './zh-CN/interests.json.js';
import jobRole from './zh-CN/job-role.json.js';
import levelOfAWSUsage from './zh-CN/level-of-aws-usage.json.js';
import projectTimeline from './zh-CN/project-timeline.json.js';
import PTStates from './zh-CN/PT-states.json.js';
import USStates from './zh-CN/US-states.json.js';
import useCase from './zh-CN/use-case.json.js';
import languagePreference from './zh-CN/language-preference.json.js';
import Navatar from '../zh-CN/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
